import { request } from './request'
import { alerts } from './modules/alerts'
import { auth } from './modules/auth'
import { boletin } from './modules/boletin'
import { chatbot } from './modules/chatbot'
import { meteogram } from './modules/meteogram'
import { geocoder } from './modules/geocoder'
import { historic } from './modules/historic'
import { language } from './modules/language'
import { pollution } from './modules/pollution'
import { report } from './modules/report'
import { simulation } from './modules/simulation'
import { sounding } from './modules/sounding'
import { stations } from './modules/stations'
import { units } from './modules/units'
import { variables } from './modules/variables'
import { historicalMeteo } from './modules/historicalMeteo'
import { lightning } from './modules/ligthning'
import { burnArea } from './modules/burnArea'
import { ens } from './modules/ens'
import { attribution } from './modules/attribution'
import { bookmarks } from './modules/bookmarks'
import { mapEvent } from './modules/mapEvent'
import { personalizedGroup } from './modules/personalizedGroup'
import { email } from './modules/email'
import { brigadas } from './modules/brigadas'
import { bulletinConfiguration } from './modules/bulletinConfiguration'
import { gimms } from './modules/gimms'
import { fileGenerator } from './modules/fileGenerator'
import { fileGeneratorLocal } from './modules/fileGeneratorLocal'
import { stripe } from './modules/stripe'
import { focAlerts } from './modules/focAlerts'
import { media } from './modules/media'
import { descargaVariablePDF } from './modules/descargaVariablePDF'
import { mosaicConfiguration } from './modules/mosaicConfiguration'
import { releaseData } from './modules/releaseData'
import { fuelModelFile } from './modules/fuelModelFile'
import { esri } from './modules/esri'
import { symbolMap } from './modules/symbolMap'
import { autonomousCommunities } from './modules/autonomousCommunities'

export default {
  request,

  alerts,

  auth,

  boletin,
  brigadas,

  chatbot,

  email,

  meteogram,

  geocoder,
  gimms,
  historic,

  language,

  pollution,

  report,
  simulation,
  sounding,
  stations,
  units,
  variables,
  historicalMeteo,
  lightning,
  ens,
  attribution,
  bookmarks,
  burnArea,
  mapEvent,
  personalizedGroup,
  bulletinConfiguration,
  fileGeneratorLocal,
  fileGenerator,
  stripe,
  focAlerts,
  media,
  descargaVariablePDF,
  mosaicConfiguration,
  releaseData,
  fuelModelFile,
  esri,
  symbolMap,
  autonomousCommunities
}
